/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DegreeInputs */

const en_degree = /** @type {(inputs: DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Degree`)
};

const de_degree = /** @type {(inputs: DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abschluss`)
};

/**
* | output |
* | --- |
* | "Degree" |
*
* @param {DegreeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const degree = /** @type {((inputs?: DegreeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DegreeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_degree(inputs)
	return en_degree(inputs)
});